var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThorchain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#ff3131;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,59.8l41.4-17.4L32.2,29.1L4,59.8z M19.4,15.7l13.2,13.2L56,0.2L19.4,15.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThorchain1);
export default __webpack_public_path__ + "static/media/Thorchain-1.41c08c1f8eec4bc42342688c52cf7d45.svg";
export { ForwardRef as ReactComponent };